<div>
  <button
    *ngIf="community.isMember && community.isMember !== null"
    type="button"
    class="btn btn-primary invite-to-community-button"
    (click)="inviteToCommunityModal.show()"
  >
    <i class="icofont icofont-plus"></i>
    <i class="icofont icofont-user-alt-2"></i>
    Invite a friend
  </button>

  <!-- Invite-to-community-modal -->
  <invite-to-community-modal
    #inviteToCommunityModal
    [community]="community"
    [hideFooter]="true"
  >
  </invite-to-community-modal>
  <!-- Invite-to-community-modal -->
</div>
